import React, { useState } from 'react';
import NavigationShell from './NavigationShell';
import WorklistNavigationContent from '../WorklistNavigationColumn';
import QANavigationContent from '../ProjectSelectColumn';
import { NavigationColumnProps } from './types';
import { NAVIGATION_COLORS, STORAGE_KEYS, SEARCH_PLACEHOLDERS } from './constants';

const NavigationColumn: React.FC<NavigationColumnProps> = (props) => {
    const [searchTerm, setSearchTerm] = useState('');

    const isWorklist = props.mode === 'worklist';

    const shellProps = {
        searchTerm,
        onSearchChange: setSearchTerm,
        searchPlaceholder: isWorklist ? SEARCH_PLACEHOLDERS.WORKLIST : SEARCH_PLACEHOLDERS.QA,
        backgroundColor: isWorklist ? NAVIGATION_COLORS.WORKLIST_BG : NAVIGATION_COLORS.QA_BG,
        storageKey: isWorklist ? STORAGE_KEYS.WORKLIST_SIDEBAR : STORAGE_KEYS.QA_SIDEBAR,
    };

    return (
        <NavigationShell {...shellProps}>
            {isWorklist ? (
                <WorklistNavigationContent
                    searchTerm={searchTerm}
                    views={props.views}
                    activeView={props.activeView}
                    onViewChange={props.onViewChange}
                    roles={props.roles}
                    onManageViewsClick={props.onManageViewsClick}
                />
            ) : (
                <QANavigationContent
                    searchTerm={searchTerm}
                    client={props.client}
                    onProjectSelected={props.onProjectSelected}
                    selectedProject={props.selectedProject}
                    selectedStatus={props.selectedStatus}
                    initialProjectId={props.initialProjectId}
                    initialStatus={props.initialStatus}
                    onCountIsLoadingChange={props.onCountIsLoadingChange}
                    onProjectUpdated={props.onProjectUpdated}
                />
            )}
        </NavigationShell>
    );
};

export default NavigationColumn;

export * from './types';
export { NAVIGATION_COLORS, STORAGE_KEYS, SEARCH_PLACEHOLDERS } from './constants';
